"use client";
import { useState } from "react";
import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "../styles/result-card-grid.css";
import { GridCardTitle } from "./GridCardTitle";
import { GridCardInfo } from "./GridCardInfo";

const ResultCardGridItem = ({ result, allMemberships }) => {
  // Get primary membership (current role or most recent)
  const currentMemberships = allMemberships?.filter((m) => !m.end_date) || [];
  const primaryMembership = currentMemberships[0] || allMemberships?.[0];

  const isSubscriber = result.subscriber === true;

  return (
    <>
      <Card
        className="h-100 shadow-sm border-0 hover-card"
        style={{
          paddingBottom: 0,
          backgroundColor: isSubscriber ? "#fffcf3" : "white",
          border: isSubscriber ? "1px solid #e9ecef" : "none",
        }}
      >
        {isSubscriber && (
          <div
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              zIndex: 10,
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="open-for-work-tooltip">Open to work</Tooltip>
              }
            >
              <i
                className="fa fa-briefcase"
                style={{
                  color: "#e47136",
                  fontSize: "16px",
                  backgroundColor: "white",
                  padding: "6px",
                  borderRadius: "50%",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  cursor: "help",
                }}
              />
            </OverlayTrigger>
          </div>
        )}

        <Card.Body
          className="d-flex flex-column p-4"
          style={{ paddingBottom: 0 }}
        >
          {/* Header Section */}
          <GridCardTitle
            id={result.id}
            name={result.name}
            primaryMembership={primaryMembership}
          />

          <GridCardInfo result={result} allMemberships={allMemberships} />
        </Card.Body>
      </Card>
    </>
  );
};

export default ResultCardGridItem;
